import { useEffect, useState } from 'react';

import { MktWrapper } from '@playbooks/components/mkt/mkt-wrapper';

import { ReferralFlow } from 'components/referral/referral-flow';
import { IndexHero } from 'mkt/index/index-hero';
import { IndexSplash } from 'mkt/index/index-splash';
import { contactsQuery, projectTypesQuery, referrerQuery } from 'queries';

const IndexRoute = props => {
	if (props.ssr.splash) return <IndexSplash contacts={props.ssr.contacts?.data || []} />;
	return <IndexContent {...props} />;
};
const IndexContent = ({ ssr, workspace, router, store }) => {
	const [open, setOpen] = useState(false);

	// Computed
	const referrer = ssr.referrer?.data || {};
	const types = ssr.projectTypes?.data || [];
	// Hooks
	useEffect(() => {
		if (referrer.id) setOpen(true);
	}, [referrer.id]);

	// Render
	return (
		<>
			<IndexHero workspace={workspace} router={router} store={store} types={types} />
			<ReferralFlow model={referrer} open={open} setOpen={setOpen} />
		</>
	);
};

IndexRoute.getLayout = (page, ssr) => {
	if (ssr.splash) return page;
	return (
		<MktWrapper seo={{ title: 'Playbooks | Transform ideas into products.' }} prefooter={false} footer={false}>
			{page}
		</MktWrapper>
	);
};

export default IndexRoute;
export async function getServerSideProps({ req, params, query }) {
	if (query.redirect) return { redirect: { destination: '/' + query.redirect } };
	const splash = query.view === 'splash';
	if (process.env.NODE_ENV !== 'development' && !splash) {
		return { redirect: { destination: '/?view=splash', permanent: false } };
	}
	if (splash) {
		let contacts = { data: [], meta: {} };
		try {
			contacts = await contactsQuery({ req, params });
		} catch {
			// Contacts are admin-protected today. Keep the public splash available when the request has no contact access.
		}
		return { props: { contacts, splash } };
	}
	const [referrer, projectTypes] = await Promise.all([
		referrerQuery({ req, params, query }),
		projectTypesQuery({ req, params }),
	]);
	return { props: { projectTypes, referrer, splash } };
}
